import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { BandwidthResult } from '../../../models/app/bandwidth-result';
import { Subscription } from 'rxjs';
import { NgTemplateOutlet, TitleCasePipe } from '@angular/common';
import { ToMbpsPipe } from '../../../shared/pipes/to-mbps.pipe';

@Component({
  selector: 'app-bandwith-test',
  imports: [NgTemplateOutlet, ToMbpsPipe, TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './bandwith-test.component.html',
})
export class BandwithTestComponent {
  result = input.required<BandwidthResult>();
  type = computed<'upload' | 'download'>(() => this.result()?.type || 'download');

  subscription: Subscription | undefined;
}
